<div>
  <div class="anchor-tab-offset-wrap">
    <div class="anchor-tab-offset" [id]="anchorId"></div>
  </div>
  <ng-content></ng-content>
</div>
